import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import HeaderBottom from './headerBottom/headerBottom'
import HeaderTop from './headerTop/headerTop'
import styles from './header.module.scss'
import withRouter from '../../hooks/withRouter'

const Header = () => {
  return (
    <div className={styles.container}>
      {/* @ts-ignore */}
      <HeaderTop />
      {/* @ts-ignore */}
      <HeaderBottom />
    </div>
  )
}

let mapStateToProps = () => {
  return {}
}

export default compose(connect(mapStateToProps, {}), withRouter)(Header)
